import React, { Component } from "react";
import { DebtbuttonNowidth } from "../../forms/button";
import { Input } from "../../forms/input";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { PasswordDialog } from "../customModal";
import { getProfileData, resetPassword } from "../../../store/actions/profile";
import { lastLoginIcon } from "../../../store/types/appEssentials";
import Image from "../../Image";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPasswordModal: false,
    };
  }
  PasswordModal() {
    this.setState({
      openPasswordModal: true,
    });
  }
  closeModal() {
    this.setState({
      openPasswordModal: false,
    });
  }

  componentDidMount() {
    this.props.getProfileData({
      Agent: this.props.token,
      UserId: this.props.userId,
    });
  }
  render() {
    const { profileData, reviewList, token } = this.props;
    const {
      Distributor_Name = "",
      City = "",
      MobileNo = "",
      PAN = "",
      Email = "",
    } = profileData;

    return (
      <div style={{ margin: "30px 5% 20px 2%" }} className="Mirae">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: 20,
          }}
        >
          <div className="profile-settings-title">Profile Settings</div>
          <DebtbuttonNowidth
            buttontitle="Change Password"
            onClick={() => this.PasswordModal()}
          />
        </div>
        <PasswordDialog
          openPasswordModal={this.state.openPasswordModal}
          closeModal={() => this.closeModal()}
          history={this.props.history}
        />
        <Paper className="flex settings-paper">
          <div className="profile-settings-left-container">
            <div className="input-less-margin">
              <Input
                name="ARN Code"
                height={15}
                value={token.split("-")[1]}
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
              />
            </div>

            <div className="input-less-margin">
              <Input
                name="Name"
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
                value={Distributor_Name || "-NA-"}
              />
            </div>

            <div className="input-less-margin">
              <Input
                name="City"
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
                value={City || "-NA-"}
              />
            </div>

            <div className="input-less-margin">
              <Input
                name="Mobile"
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
                value={MobileNo || "-NA-"}
              />
            </div>

            <div className="input-less-margin">
              <Input
                name="Email ID"
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
                value={Email || "-NA-"}
              />
            </div>

            <div className="input-less-margin">
              <Input
                name="PAN"
                bordercolor="rgba(0,0,0,0.3)"
                disabled={true}
                value={PAN || "-NA-"}
              />
            </div>
          </div>
          <div className="profile-settings-right-container">
            <div className="profile-settings-review">Review</div>
            <div className="flex-for-settings" style={{ marginBottom: 20 }}>
              <div
                style={{
                  width: "50%",
                  marginLeft: 30,
                  fontSize: 14,
                }}
              >
                Year
              </div>
              <div
                style={{
                  width: "50%",
                  marginLeft: 20,
                  fontSize: 14,
                }}
              >
                Self Declaration Status
              </div>
            </div>
            {reviewList.slice(0, 9).map((item, index) => (
              <React.Fragment key={index}>
                <SubmitList
                  fromYear={item.From_Year}
                  toYear={item.To_Year}
                  confirmation={item["Self Declaration Status"]}
                />
                {index !== reviewList.length - 1 && index < 8 && <BlueLine />}
              </React.Fragment>
            ))}
          </div>
        </Paper>
      </div>
    );
  }
}

export class SubmitList extends Component {
  render() {
    const { fromYear, toYear, confirmation } = this.props;
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "50%", display: "flex" }}>
          <div>
            <Image
              src={lastLoginIcon}
              alt="timer_background"
              style={{ height: 20, margin: "0px 5px" }}
            />
          </div>
          <div className="profile-settings-submit-year">
            {fromYear} - {toYear}
          </div>
        </div>

        <div className="profile-settings-submit-container">
          <Image
            src={
              confirmation === "Submitted"
                ? "/images/tick.svg"
                : "/images/cross.png"
            }
            alt={confirmation === "Submitted" ? "submitted" : "not_submitted"}
            style={{ height: 10, marginRight: 10 }}
          />

          <div
            style={{
              fontSize: 12,
              color: confirmation === "Submitted" ? "#005DAC" : "#df7b71",
            }}
          >
            {confirmation}
          </div>
        </div>
      </div>
    );
  }
}

export class BlueLine extends Component {
  render() {
    return (
      <div
        style={{
          width: 3,
          height: 30,
          backgroundColor: "#fef5ec",
          margin: "-3px 13px",
        }}
      />
    );
  }
}

const MapStatetoProps = ({ authReducer, profileReducer }) => {
  const { token, userId } = authReducer;
  const { profileData, reviewList } = profileReducer;
  return { token, userId, profileData, reviewList };
};

export default connect(MapStatetoProps, { getProfileData, resetPassword })(
  Settings
);
